import React from "react";

const Footer: React.FC = () => {
  return (
    <footer>
      <p className="font-code">
        Designed & Built by Monika Intaitė using React.js
      </p>
    </footer>
  );
};

export default Footer;
